(function () {
  document.querySelectorAll('.hw-modal').forEach(function (modal) {
    var media = modal.querySelector('.hw-modal__media');
    var template = modal.querySelector('template');
    if (!media || !template) return;
    media.addEventListener('pointerup', function (event) { event.stopPropagation(); });
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        media.replaceChildren(template.content.cloneNode(true));
      } else {
        media.replaceChildren();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
})();
